"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _homeletModule = _interopRequireDefault(require("./homelet.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Homelet = function Homelet(_ref) {
  var children = _ref.children,
      className = _ref.className,
      contentBackground = _ref.contentBackground,
      header = _ref.header,
      footer = _ref.footer,
      footerCenter = _ref.footerCenter,
      footerRight = _ref.footerRight;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_homeletModule["default"].homelet, className)
  }, header ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _homeletModule["default"].badge
  }, header)) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_homeletModule["default"].homeletContent, 'flex-1 flex rounded-sm overflow-auto mt-0 mr-6 mb-6 ml-6 md:mt-0 md:mr-0 md:mb-6 md:ml-0 ', {
      'pb-10 justify-center': contentBackground
    })
  }, children), footer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('mt-4 flex', {
      'justify-center': footerCenter,
      'justify-end': footerRight
    })
  }, footer) : null);
};

Homelet.propTypes = {
  header: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string.isRequired,
  contentBackground: _propTypes["default"].bool,
  footerCenter: _propTypes["default"].bool,
  footerRight: _propTypes["default"].bool
};
Homelet.defaultProps = {
  header: null,
  contentBackground: false,
  footerCenter: false,
  footerRight: false,
  footer: null,
  children: null
};
var _default = Homelet;
exports["default"] = _default;